import { render, staticRenderFns } from "./PipelineSettings.vue?vue&type=template&id=12b4d7c4"
import script from "./PipelineSettings.vue?vue&type=script&lang=js"
export * from "./PipelineSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports